"use strict";
const createSearchStringQueryForPurchasing = require('./create-search-string-query-for-purchasing');
module.exports = {
    createSearchStringQueryForPurchasing,
};
